


// import axiosInstance from '../../config';

// export const adminGetCopierService = async (token) => {

//     try {


//         const response = await axiosInstance.get('/copier/get_copier_details',
//             {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json",
//             },

//         })





//         return {
//             success: true,
//             data: response.data,
//             status: response.status,

//         };


//     }
//     catch (error) {

//         return {
//             success: false,
//             message: error.response?.data?.message || "Fetch Copier failed",
//             status: error.response?.status || 500,
//             errors: error.response?.data?.errors || null,


//         };

//     }


// }



import axiosInstance from '../../config';

export const adminGetCopierService = async (token) => {

    try {

        const response = await axiosInstance.get('/copier/get_copier_details',

            {
                headers: {
                    Authorization: `Bearer ${token}`, 
                    "Content-Type": "application/json",
                },
            })




        return {

            success: true,

            data: response.data,

            status: response.status,

        };

    }

    catch (error) {

        return {

            success: false,

            message: error.response?.data?.message || "Fetch Copier failed",

            status: error.response?.status || 500,

            errors: error.response?.data?.errors || null,

        };

    }

}